import { render, staticRenderFns } from "./AccountBoxSlideList.vue?vue&type=template&id=74fed651&"
import script from "./AccountBoxSlideList.vue?vue&type=script&lang=ts&"
export * from "./AccountBoxSlideList.vue?vue&type=script&lang=ts&"
import style0 from "./AccountBoxSlideList.vue?vue&type=style&index=0&id=74fed651&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports